'use client';

import { useState } from 'react';

// CAROUSEL
import 'keen-slider/keen-slider.min.css';
import { useKeenSlider } from 'keen-slider/react';

import get from 'lodash/get';
import map from 'lodash/map';
import Arrows from '@/components/carousels/arrow/Arrow';


const Carousel = ({ children, options, className = '' }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [loaded, setLoaded] = useState(false);

  const childrenLength = children.length;

  const sliderOptions = {
    slides: children?.length,
    loop: false,
    autoplay: false,
    initial: 0,
    created() {
      setLoaded(true);
    },
    ...options,
  };

  const [sliderRef, instanceRef, ...rest] = useKeenSlider(sliderOptions, [
    slider => {
      let timeout;
      let mouseOver = false;

      function clearNextTimeout() {
        clearTimeout(timeout);
      }

      function nextTimeout() {
        if (!sliderOptions.autoplay) {
          return;
        }
        clearTimeout(timeout);
        if (mouseOver) return;
        timeout = setTimeout(() => {
          slider.next();
        }, 3000);
      }

      slider.on('created', () => {
        setLoaded(true);
        slider.container.addEventListener('mouseover', () => {
          mouseOver = true;
          clearNextTimeout();
        });
        slider.container.addEventListener('mouseout', () => {
          mouseOver = false;
          nextTimeout();
        });
        nextTimeout();
      });
      slider.on('dragStarted', clearNextTimeout);
      slider.on('animationEnded', nextTimeout);
      slider.on('updated', nextTimeout);
    },
  ]);

  if (!childrenLength) {
    return null;
  }

  return (
    <div className={`relative ${className}`}>
      {get(options, 'arrows', false) && loaded && instanceRef.current ? (
        <Arrows
          slider={instanceRef}
          alwaysOn={sliderOptions?.loop}
          currentSlide={
            currentSlide > 0 ? currentSlide + sliderOptions.slidesPerView : 0
          }
        />
      ) : (
        ''
      )}
      <div ref={sliderRef} className="keen-slider">
        {map(children, (child, index) => (
          <div
            className={`keen-slider__slide number-slide-${index}`}
            key={`carousel--${index}`}
          >
            {child}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Carousel;
